<template lang="html">
  <div>
    <b-form class="box-cart-express" @submit="onSubmit">
      <!-- <div class="box-quantity">
        <div class="txt">Cant: </div>
        <b-form-spinbutton required v-model="quantity" inline></b-form-spinbutton>
      </div> -->

      <!-- <div class="box-quantity">
        DESCOMENTAR LUEGO
        <div class="txt">Cant: </div>

        <div class="col-quantity2">
          <a class="form-control btn-q" @click="changeCantidad('-')">
            <i class="fal fa-minus"></i>
          </a>
          <output>
            <b-form-input class="input-q" type="number" min="0" v-model="quantity" @keypress="isNumber($event)" @paste="noPaste" />
          </output>
          <a class="form-control btn-q" @click="changeCantidad('+')">
            <i class="fal fa-plus"></i>
          </a>
        </div>
      </div>
      <b-button type="submit" class="btn-more outline">Comprar</b-button> -->

      
      <!-- <a class="btn-more outline">Agregar producto</a> -->
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    obj: {
      id: null,
      name: null,
      modelo:null,
      stock:null,
      image:null
    }, // Aqui se pasará un object con lo necesario para agregar a carrito
  },

  data(){
    return{
      quantity: 0,
    }
  },

  watch: {
    'quantity' : function(value, oldValue){
      if( value < 1 || value > 100 ){
        setTimeout( ()=>{ this.quantity = null; }, 100);
      }
    },
  },

  methods: {
    noPaste(evt){
      event.preventDefault();
    },

    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    changeCantidad($type){
      if (this.quantity == null) {
        this.quantity = 0;
      }
      else{
        this.quantity = parseInt(this.quantity);
      }

    
      if ($type == '-') {
       // this.quantity = (this.quantity > 1) ? --this.quantity : 1;
        this.quantity = --this.quantity;
      }
      else{
        //this.quantity = (this.quantity < 100) ? ++this.quantity : 100;
        this.quantity = ++this.quantity ;
      }
    },

    onSubmit(event) {
      event.preventDefault();

      if(this.quantity <= 0){
        this.$root.modalCartObj.msg = 'Necesita agregar al menos 1 producto';
        this.$root.modalCartObj.icon = 'error';
        this.$root.modalCartObj.block = false;

        this.$root.openModalCart = true; // Asi se abre el modal
      }
      else{
        // ** CODIGO PARA AGREGAR PRODUCTO AQUI ***

        var cart = [];
        var encontrado = false;

        if(localStorage.cart){
          cart = JSON.parse(localStorage.getItem('cart'));

          for(var i = 0; i < cart.length ; i++){
            if(cart[i].id == this.obj.id && cart[i].modelo == this.obj.modelo)
            {
              var suma = cart[i].quantity + this.quantity;
              cart[i].quantity = suma;// <= this.obj.stock ? suma : this.obj.stock;
              encontrado = true;
              break;
            }
          }

          if(!encontrado){
            cart.push({ id:this.obj.id, quantity:this.quantity, modelo: this.obj.modelo, imageUrl: this.obj.image });
          }
        } else{
          cart.push({ id:this.obj.id, quantity:this.quantity, modelo: this.obj.modelo, imageUrl: this.obj.image });
        }
        localStorage.setItem("cart",JSON.stringify(cart));
        this.$root.cartCount = cart.length;

        this.$root.modalCartObj.msg = 'El producto <strong>'+this.obj.name+'</strong> se agregó al carrito en <strong>'+this.quantity+'</strong> unidades';
        this.$root.modalCartObj.icon = 'success';
        this.$root.modalCartObj.block = false;

        this.$root.openModalCart = true; // Asi se abre el modal
        //this.quantity = 0; // Resetear cantidad
      }
    },
  },
  beforeMount(){
      var storage = localStorage.getItem('cart');
      if(storage != null){
          var products = JSON.parse(storage);
          for(var i = 0; i < products.length ; i++){
            if(products[i].id == this.obj.id && products[i].modelo == this.obj.modelo)
            {
                this.quantity = products[i].quantity;
                break;
            }
          }
      }
  }
}
</script>
